  import { isWeb } from '@livekit/components-core';
  import { RoomEvent, Track } from 'livekit-client';
  import * as React from 'react';

  import {
    ConnectionStateToast,
    LayoutContextProvider,
    RoomAudioRenderer,
    useCreateLayoutContext,
    useTracks,
    VideoTrack, 
    useRemoteParticipants
  } from '@livekit/components-react';

  import VideoControls from './VideoControlsList';

  import './CustomVideoConference.css'


  export default function VideoConference({
    chatMessageFormatter,
    chatMessageDecoder,
    chatMessageEncoder,
    SettingsComponent,
    ...props
  }) {
  
    const tracks = useTracks(
      [
        { source: Track.Source.Camera, withPlaceholder: false },
        { source: Track.Source.ScreenShare, withPlaceholder: false },
      ],
      { updateOnlyOn: [RoomEvent.ActiveSpeakersChanged], onlySubscribed: false },
    );
  
    const layoutContext = useCreateLayoutContext();

    const participants = useRemoteParticipants()
    const participantsAmount = React.useMemo(()=>participants.length, [participants])
  
    return (
      <div>
        <p>Студентов онлайн: {participantsAmount}</p>
        <div className="lk-video-conference bg-black rounded-2xl my-4 relative overflow-hidden teacher-stream" {...props}>
          {isWeb() && (
            <LayoutContextProvider
              value={layoutContext}
            >
              <div className="lk-video-conference-inner">
              {tracks && tracks.length ?
                <div className={`flex relative items-center lk-video-conference-inner`}>
                  { 
                    tracks.map(track => <div className={`${track.source} tracks-${tracks.length}`}>
                      <VideoTrack key={track.publication.trackSid} trackRef={track} />
                    </div> )
                  }
                </div> :
                <div className='min-h-[40vh] md:min-h-[536px]'></div>
              }
                <VideoControls />
              </div>
            </LayoutContextProvider>
          )}
          <RoomAudioRenderer />
          <ConnectionStateToast />
        </div>
      </div>
    );
  }
  